import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router";
import { routes } from "~/lib/constants";

export const CallbackPage = () => {
  const auth = useAuth();
  if (auth.isLoading) {
    return <div>Processing login callback...</div>;
  }
  if (auth.error) {
    return (
      <div>
        <p>Login Error!</p>
        <p>{auth.error.message}</p>
        <p>Please try logging in again.</p>
      </div>
    );
  }
  if (auth.isAuthenticated) {
    return <Navigate to={routes.dashboard.taskManager} replace />;
  }
  // Fallback
  return <Navigate to="/" replace />;
};
